<script>
    import SimpleSelect from '../SimpleSelect.svelte';
    import { RemovalStatuses } from 'src/store/removal-status';

    export let value;

    $: items = $RemovalStatuses.map(({ id: value, name: label }) => ({ value, label }));
</script>

<SimpleSelect
    {items}
    bind:value
/>
